import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueHtmlToPaper from 'vue-html-to-paper';
import i18n from '@/plugins/i18n';

const options = {
  name: '_blank',
  styles: [
    "https://cdn.rtlcss.com/bootstrap/v4.2.1/css/bootstrap.min.css"
  ]
}

Vue.use(VueHtmlToPaper, options);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
